export default class DraggableTableRows {
    constructor(selector = '.draggable-rows') {
        this.table = document.querySelector(selector);
        if (!this.table) return;

        this.rows = this.table.querySelectorAll('tbody tr');
        this.draggingRow = null;

        // if (this.rows.length === 0) {
        //     console.log('No draggable rows found.');
        // } else {
        //     console.log(`Found ${this.rows.length} draggable rows.`);
        // }

        this.initRows();
        this.initViewToggle();
    }

    initRows() {
        this.rows.forEach(row => {
            row.draggable = true;

            row.addEventListener('dragstart', e => this.onDragStart(e, row));
            row.addEventListener('dragend', () => this.onDragEnd());

            row.addEventListener('dragover', e => this.onDragOver(e));
            row.addEventListener('dragenter', e => this.onDragEnter(e, row));
            row.addEventListener('dragleave', () => this.onDragLeave(row));

            row.addEventListener('drop', e => this.onDrop(e, row));
        });
    }

    onDragStart(event, row) {
        this.draggingRow = row;
        row.classList.add('dragging');
        event.dataTransfer.effectAllowed = 'move';
    }

    onDragEnd() {
        // remove dragging class from all rows
        this.rows.forEach(r => r.classList.remove('dragging', 'drag-over'));
        this.draggingRow = null;
    }

    onDragOver(event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }

    onDragEnter(event, row) {
        event.preventDefault();
        if (row !== this.draggingRow) row.classList.add('drag-over');
    }

    onDragLeave(row) {
        row.classList.remove('drag-over');
    }

    onDrop(event, row) {
        event.preventDefault();
        if (!this.draggingRow || this.draggingRow === row) return;

        const tbody = row.closest('tbody');
        const middleY = row.getBoundingClientRect().top + row.offsetHeight / 2;

        if (event.clientY < middleY) {
            tbody.insertBefore(this.draggingRow, row);
        } else {
            tbody.insertBefore(this.draggingRow, row.nextSibling);
        }

        row.classList.remove('drag-over');
    }

    initViewToggle() {
        const container = this.table.closest('.weekly-results');
        if (!container) return;

        const buttons = container.querySelectorAll('.change-view-btn');
        if (!buttons.length) return;

        buttons.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();

                const viewClass = btn.dataset.view;

                // remove active state
                buttons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');

                // explicitly remove both theme classes
                this.table.classList.remove('vertical-theme', 'horizontal-theme');

                // apply new view class
                if (viewClass) this.table.classList.add(viewClass);
            });
        });
    }
}